import Flickity from 'flickity'

class TwoUpWithCarousel extends HTMLElement {
  constructor () {
    super ()

    this.carouselEl = null
    this.carouselInstance = null
    this.carouselOptions = {
      cellSelector: '.js-two-up-carousel-slide',
      cellAlign: 'left',
      contain: false,
      prevNextButtons: true,
      pageDots: false
    }

    this.cleanupFuncs = []
  }

  connectedCallback () {
    this.carouselEl = this.querySelector('.js-two-up-carousel')

    this.initCarousel()
    this.cleanupFuncs.push(() => this.destroyCarousel())

    document.dispatchEvent(new CustomEvent('product-item:should-load', {
      detail: {
        parent: this
      }
    }))
  }

  disconnectedCallBack() {
    this.cleanupFuncs.forEach(func => func.call(this))
  }

  destroyCarousel() {
    if (!this.carouselInstance) return

    this.carouselInstance.destroy()

    this.carouselInstance = null
  }

  initCarousel() {
    if (!this.carouselEl) return

    this.destroyCarousel()

    this.carouselInstance = new Flickity(this.carouselEl, this.carouselOptions)
  }
}

customElements.define('two-up-with-carousel', TwoUpWithCarousel)
